import { j as r } from "./atoms-v218.js";
import { useRef as x, useState as p, useEffect as y, useMemo as h } from "react";
import { SLIDE_TRANSITION as j } from "./atoms-v21045.js";
import { SlidesHorizontal as H, SlideButton as I, HorizontalWrapper as R, SlideNumber as T, RoundedImageV2 as B, SlideDetails as N, SlideHorizontal as $ } from "./atoms-v2819.js";
import { Text as g } from "./atoms-v243.js";
import { useMotionValue as A } from "./atoms-v2879.js";
import { motion as S } from "./atoms-v2709.js";
import { useInView as D } from "./atoms-v2951.js";
import { wrap as M } from "./atoms-v2982.js";
const _ = ({ children: s, size: l }) => {
  const e = x(null), t = D(e, { once: !0 }), c = h(() => S($), []);
  return /* @__PURE__ */ r.jsx(
    c,
    {
      $size: l,
      animate: { opacity: t ? 1 : 0 },
      initial: { opacity: 0 },
      ref: e,
      transition: j,
      children: s
    }
  );
}, V = ({
  handleOnView: s,
  i18n: l,
  slides: e
}) => {
  const t = x(null), c = A(0), [d, z] = p(0), [u, v] = p(0), [w, W] = p(0);
  y(() => {
    if (t === null || t.current === null)
      return;
    const a = () => {
      var n;
      v(((n = t.current) == null ? void 0 : n.scrollWidth) || 0);
    }, i = () => {
      var n;
      z(((n = t.current) == null ? void 0 : n.clientWidth) || 0);
    }, o = () => {
      W(u - d);
    };
    return a(), i(), o(), window.addEventListener("resize", i), window.addEventListener("resize", o), () => {
      window.removeEventListener("resize", i), window.removeEventListener("resize", o);
    };
  }, [t, u, d]);
  const b = h(() => S(H), []), C = h(() => S(I), []), f = ["md", "sm", "sm"], E = u > d;
  return console.log(e), /* @__PURE__ */ r.jsx(R, { bleed: !0, large: 7, offset: { large: 1, xLarge: 1 }, span: 15, children: /* @__PURE__ */ r.jsx(
    b,
    {
      ref: t,
      ...E ? {
        drag: "x",
        dragConstraints: {
          left: -w,
          right: 0
        },
        initial: { x: 0 },
        style: { x: c },
        transition: j,
        whileHover: { cursor: "grab" },
        whileTap: { cursor: "grabbing" }
      } : null,
      children: e && e.length > 0 ? e.map(({ caption: a, id: i, title: o, ...n }, m) => {
        const L = f[M(0, f.length, m)];
        return /* @__PURE__ */ r.jsxs(_, { size: L, children: [
          /* @__PURE__ */ r.jsx(T, { children: String(m + 1).padStart(3, "0") }),
          /* @__PURE__ */ r.jsx(B, { aspectRatio: m % 3 === 0 ? "2/3" : "3/4", id: i, ...n }),
          a || o ? /* @__PURE__ */ r.jsxs(N, { children: [
            o && /* @__PURE__ */ r.jsx(g, { type: "heading", variant: "03", children: o }),
            a && /* @__PURE__ */ r.jsx(g, { type: "helper", variant: "productive", children: a })
          ] }) : null,
          s && /* @__PURE__ */ r.jsx(
            C,
            {
              "aria-label": l == null ? void 0 : l.slideButtonAriaLabel,
              onTap: () => s == null ? void 0 : s(i),
              type: "button"
            }
          )
        ] }, i);
      }) : null
    }
  ) });
};
export {
  V as Variant2
};
